import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { translate } from '../../utils/useful'
import { languagesInfo, siteTheme } from '../../variables/config'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import i18n from 'i18next';
import Responsive from '../../components/Responsive'
import ButtonAnimated from '../../components/buttons/ButtonAnimated'

class LoginFirstStep extends React.Component {
    state = {
        key: '',
        selectedCountry: {},
        data: {},
        isLoading: false,
        formHeaders: [],
        show: true
    }

    componentDidMount() {
        let formHeaders = [{ key: 'userIndicator', type: 'PhoneInput', information: { placeholder: '{{lang}}phonenumber', autoFocus: true, required: true } }]
        if (this.props.initData.indicatorType && this.props.initData.indicatorType === 'email') {
            formHeaders = [{ key: 'userIndicator', type: 'EmailInput', information: { placeholder: '{{lang}}phonenumber', autoFocus: true, required: true } }]
        }
        document.addEventListener("keydown", this._handleKeyDown);
        this.setState({ formHeaders })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.textColor != this.props.textColor && this.props.textColor) {
            this.setState({ show: false }, () => {
                this.setState({ show: true })
            })
        }
    }


    componentWillUnmount = () => {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.userCheck()
        }
    }




    userCheck = () => {
        let data = this.form.getForm()
        if (data) {
            this.setState({ isLoading: true, errors: {} })
            this.props.setData(data, () => {
                this.props.userCheck((result, err) => {
                    if (err) { this.setState({ errors: err }) }
                    this.setState({ isLoading: false })
                })
            })
        }
    }


    toggleLanguagesBox() {
        if (!this.state.showLanguagesBox) {
            document.addEventListener('mousedown', this.closeBox);
            this.setState({ showLanguagesBox: true })
        } else {
            this.closeBox()
        }
    }

    closeBox = (event) => {
        if (!event || (this.language_select_box && !this.language_select_box.contains(event.target))) {
            document.removeEventListener('mousedown', this.closeBox);
            let box = document.querySelectorAll('.language-select-box')
            if (box) {
                box[0].classList.add('fadeout')
            }

            setTimeout(() => {
                this.setState({ showLanguagesBox: false })
            }, 400);
        }
    }



    changeLanguage = (key, value) => {
        i18n.changeLanguage(value)
        this.closeBox()
    }



    render() {
        return (
            <div className="d-flex w-100 flexcc">

                <div className='px-3 w-100 flexcc'>

                    <div className="w-100 pb-5" style={{ maxWidth: 400, }}>

                        {this.state.show &&
                            <div className='px-3' >
                                <p className='pt-3 mt-5 mb-0 font-size-18 weight-600' style={{ background: this.props.textColor, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{translate("To sign in or sign up")}</p>
                                <p className='pb-3 font-size-30 weight-700 ' style={{ background: this.props.textColor, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}> {translate("Welcome to Yonnect")}</p>
                            </div>
                        }

                        <div className='px-3'>
                            <p className='required pb-3' >{translate("Insert your phone number")}</p>
                            <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} data={this.props.initData} initData={this.props.initData} errors={this.state.errors} inputClass={'phone-input'} nopadding={true} />
                        </div>

                        <div className="w-100 px-3">
                            <ButtonAnimated icon={'/assets/icons/arrow-right-white.svg'} bg={this.props.textColor} title={'Submit'} onClick={this.userCheck} isLoading={this.state.isLoading} />
                            <p className='pt-4 main-color1' style={{ fontSize: 13, opacity: 0.5, marginTop: 10 }}>{translate('cookie-warning')}</p>
                            <div className="flexc w-100 mt-3">
                                {languagesInfo[this.props.settings.language] && (
                                    <div className=" " style={{ position: 'relative', }}>
                                        <button onClick={() => this.toggleLanguagesBox()} className="flexcc language-but p-0">
                                            <img className="" src={languagesInfo[this.props.settings.language].icon} height="20px" alt="" />
                                            <span className=" mld-2" style={{ color: siteTheme.themeColors.headerFont }}>{languagesInfo[this.props.settings.language].name}</span>
                                        </button>
                                        {this.state.showLanguagesBox && (
                                            <div ref={el => this.language_select_box = el} className="blur-back language-select-box fadein">
                                                {Object.values(languagesInfo).map((prop, index) => {
                                                    return (
                                                        <button key={index} className={" flexc language-select-option " + (index !== 0 ? "mt-3" : '')} onClick={() => this.changeLanguage('language', prop.shortName)}>
                                                            <img className="mrd-2 opacity-5" src={prop.icon} alt={"language-" + prop.name} />
                                                            <div>{prop.name}</div>
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginFirstStep);
